const QUICK = [
  { label: "本期封面", href: "#top" },
  { label: "事件查询", href: "#events" },
  { label: "人物专题", href: "#people" },
  { label: "现场热议", href: "#hot" },
  { label: "全网热搜", href: "#trend" },
];

const LOOKUP = [
  "红毯风波",
  "录音门",
  "解约传闻",
  "旧番考古",
  "路透对比",
  "人物档案",
];

export default function Footer() {
  return (
    <footer id="subscribe" className="bg-[#efe7d8]">
      <div className="mx-auto max-w-7xl px-4 pb-8 pt-14 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          {/* brand */}
          <div className="lg:col-span-5">
            <a href="#top" className="flex items-center gap-2.5 whitespace-nowrap">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-red-700 font-serif-sc text-2xl font-black text-[#f7f3eb]">
                曝
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-serif-sc text-2xl font-black tracking-tight text-stone-900">网曝网</span>
                <span className="mt-1 text-[9px] tracking-[0.32em] text-red-700 uppercase">Gossip Ledger</span>
              </span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-6 text-stone-600">
              网曝网关键词搜索查找功能，支持事件查询、人物专题与站内查找。吃瓜爆料一搜即得，做你随身携带的爆料情报站。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <a href="#top" aria-label="微博" className="flex h-9 w-9 items-center justify-center rounded-full bg-white text-stone-600 transition-colors hover:bg-red-700 hover:text-[#f7f3eb]">
                <i className="ri-weibo-fill w-4 h-4 flex items-center justify-center"></i>
              </a>
              <a href="#top" aria-label="视频号" className="flex h-9 w-9 items-center justify-center rounded-full bg-white text-stone-600 transition-colors hover:bg-red-700 hover:text-[#f7f3eb]">
                <i className="ri-video-chat-line w-4 h-4 flex items-center justify-center"></i>
              </a>
              <a href="#top" aria-label="小报" className="flex h-9 w-9 items-center justify-center rounded-full bg-white text-stone-600 transition-colors hover:bg-red-700 hover:text-[#f7f3eb]">
                <i className="ri-newspaper-line w-4 h-4 flex items-center justify-center"></i>
              </a>
              <a href="#top" aria-label="邮件" className="flex h-9 w-9 items-center justify-center rounded-full bg-white text-stone-600 transition-colors hover:bg-red-700 hover:text-[#f7f3eb]">
                <i className="ri-mail-line w-4 h-4 flex items-center justify-center"></i>
              </a>
            </div>
          </div>

          {/* quick */}
          <div className="lg:col-span-2">
            <h4 className="text-sm font-bold text-stone-800">快速导航</h4>
            <ul className="mt-4 space-y-2.5">
              {QUICK.map((q) => (
                <li key={q.href}>
                  <a href={q.href} className="text-sm text-stone-600 transition-colors hover:text-red-700">
                    {q.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* lookup words */}
          <div className="lg:col-span-3">
            <h4 className="text-sm font-bold text-stone-800">站内查找 · 网曝网关键词</h4>
            <ul className="mt-4 flex flex-wrap gap-2">
              {LOOKUP.map((w) => (
                <li key={w}>
                  <a
                    href="#search"
                    className="inline-flex whitespace-nowrap rounded-full bg-white px-3 py-1.5 text-xs text-stone-600 transition-colors hover:bg-red-700 hover:text-[#f7f3eb]"
                  >
                    {w}
                  </a>
                </li>
              ))}
            </ul>
            <p className="mt-4 text-xs leading-5 text-stone-500">
              站内查找让每一段事件、每一个人物都能被快速定位，吃瓜不再大海捞针。
            </p>
          </div>

          {/* statement */}
          <div className="lg:col-span-2">
            <h4 className="text-sm font-bold text-stone-800">关于与声明</h4>
            <ul className="mt-4 space-y-2.5 text-sm text-stone-600">
              <li>
                <a href="#top" className="transition-colors hover:text-red-700">关于网曝网</a>
              </li>
              <li>
                <a href="#top" className="transition-colors hover:text-red-700">投稿与爆料</a>
              </li>
              <li>
                <a href="#top" className="transition-colors hover:text-red-700">版权声明</a>
              </li>
              <li>
                <a href="#top" className="transition-colors hover:text-red-700">内容纠错</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="magazine-rule mt-12 h-px w-full"></div>

        <div className="mt-5 flex flex-col items-center justify-between gap-3 sm:flex-row">
          <p className="text-center text-xs text-stone-500 sm:text-left">
            © 2026 网曝网 · 网曝网搜索 / 网曝网事件查询 / 网曝网人物专题 / 网曝网站内查找 一站式吃瓜平台
          </p>
          <p className="text-xs text-stone-400">理性吃瓜 · 尊重事实 · 拒绝造谣</p>
        </div>
      </div>
    </footer>
  );
}